import { useState } from "react";
import { StringLiteralLike } from "typescript";

export const getDashboardAgentStatistics = async (allQueue:any) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getDashboardAgentStatistics`, {
        method: "POST",
        body: JSON.stringify({queueIds:allQueue}),
    });
    if (!response.ok) throw new Error("Error Response - " + response.status);
    return await response.json();
}
export const getDashboardAverageHandledTime = async (agentUsername:string, timeFrame:string, localTime:string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getDashboardAverageHandledTime`, {
		method: "POST",
		body: JSON.stringify({agentUsername:agentUsername, timeFrame:timeFrame, localTime:localTime}),
	});
	if (!response.ok) throw new Error("Error Response - " + response.status);
	return await response.json();
}
export const getDashboardContactStatistics = async (agentUsername:string, timeFrame:string, localTime:string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getDashboardContactStatistics`, {
		method: "POST",
		body: JSON.stringify({agentUsername:agentUsername, timeFrame:timeFrame, localTime:localTime}),
	});
	if (!response.ok) throw new Error("Error Response - " + response.status);
	return await response.json();
}
export const getDashboardContactStatisticsCCP = async (queueIds:string, timeFrame:string, channel:any, localTime:string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getDashboardContactStatisticsCCP`, {
		method: "POST",
		body: JSON.stringify({queueIds:queueIds, timeFrame:timeFrame, channel:channel, localTime:localTime}),
	});
	if (!response.ok) throw new Error("Error Response - " + response.status);
	return await response.json();
}
export const getDashboardQueueStatistics = async (queueIds:string, timeFrame:string, localTime:string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getDashboardQueueStatistics`, {
		method: "POST",
		body: JSON.stringify({queueIds:queueIds, timeFrame:timeFrame, localTime:localTime}),
	});
	if (!response.ok) throw new Error("Error Response - " + response.status);
	return await response.json();
}

export const getCallbackList = async (profileARN:any) => {
	let response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}get-callback-table`, {
		method: "POST",
		headers: {"Content-Type": "application/json"},
		body: JSON.stringify({
			routing_profile: profileARN,
		}),
	})
	if (!response.ok) throw new Error("Error Response - " + response.status);
	return await response.json();
}

export const markCallbackCompleted = async (contactId: string, agentUsername: string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}set-callback-completed`, {
		method: "POST",
		headers: {"Content-Type": "application/json"},
		body: JSON.stringify({
			agent_id: agentUsername,
			contact_id: contactId,
		}),
	})
	return (response.ok) ? true : false;
}

export const markCallbackPending = async (contactId: string, agentUsername: string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}set-callback-pending`, {
		method: "POST",
		headers: {"Content-Type": "application/json"},
		body: JSON.stringify({
			agent_id: agentUsername,
			contact_id: contactId,
		}),
	})
	return (response.ok) ? true : false;
}

export const getVoicemailList = async (profileARN:any) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}get-voicemail-table`, {
		method: "POST",
		body: JSON.stringify({
			agent_name : profileARN,
		}),
	});

	if (!response.ok) throw new Error("Non-200 response: " + response.status);
	return await response.json();
}

export const hideVoicemail = async (contactId: string, agentName:string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}set-voicemail-hidden`, {
		method: "POST",
		body: JSON.stringify({
			contact_id: contactId,
			agent_name: agentName,
		}),
	});
	return (response.ok) ? true : false;
}

export const unhideVoicemail = async (contactId: string, agentName:string) => {
	const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}set-voicemail-unhidden`, {
		method: "POST",
		body: JSON.stringify({
			contact_id: contactId,
			agent_name: agentName,
		}),
	});
	return (response.ok) ? true : false;
}

export const getVoicemailPlayURL = async(contactId: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}get-vm-audio-url`, {
    	method: "POST",
    	body: JSON.stringify({
    		contact_id:contactId,
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Not able to get play", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result.url}
	}
}

export const getSentMailList = async(workmailDomain:any, emailType:any, exclusiveStartKey:any) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getSendMailList`, {
    	method: "POST",
		body: JSON.stringify({
			workmailDomain: workmailDomain,
			emailType: emailType,
			exclusiveStartKey: exclusiveStartKey
    	})
    });
    if(!response.ok) {
		return {success: false, message: "Not able to get play", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const getInboxMailList = async(workmailDomain:any, emailType:any, exclusiveStartKey:any) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getInboxMailList`, {
    	method: "POST",
		body: JSON.stringify({
			workmailDomain: workmailDomain,
			emailType: emailType,
			exclusiveStartKey: exclusiveStartKey
    	})
    });
    if(!response.ok) {
		return {success: false, message: "Not able to get play", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const searchEmails = async(searchKey:any, workmailDomain:any, emailType:any) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}searchEmails`, {
    	method: "POST",
		body: JSON.stringify({
			workmailDomain: workmailDomain,
			emailType: emailType,
			searchKey: searchKey
    	})
    });
    if(!response.ok) {
		return {success: false, message: "Not able to get play", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const getRawEmailContent = async(emailType:string,messageId: string, workmailDomain:string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getRawEmailContent`, {
    	method: "POST",
    	body: JSON.stringify({
			emailType:emailType,
    		messageId:messageId,
			workmailDomain:workmailDomain
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Not able to get play", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const sendRawEmail = async(emailDetails:any) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}SendRawEmail`, {
		method: "POST",
		body: JSON.stringify(emailDetails),
    });
    if(!response.ok) {
		return {success: false, message: "Not able to get play", data:null}
	} else {
		let result = await response.json()
		if(result.statusCode === 200) {
			return {success: true, message: 'success', data:result}
		} else {
			return {success: false, message: 'failed', data:result}
		}
	}
}

export const addEmailSignature = async(username: string, signatureName:string, signature:string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}addEmailSignature`, {
    	method: "POST",
    	body: JSON.stringify({
    		username:username,
			signatureName:signatureName,
			signature:signature
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to set email signature", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const getEmailSignatureList = async(username: StringLiteralLike) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getEmailSignatureList`, {
    	method: "POST",
    	body: JSON.stringify({
    		username:username
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to set email signature", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const updateEmailSignature = async(signatureId: string, signature:string, signatureName:string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}updateEmailSignature`, {
    	method: "POST",
    	body: JSON.stringify({
    		signatureId:signatureId,
			signature:signature,
			signatureName:signatureName
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to update email signature", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const deleteEmailSignature = async(signatureId: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}deleteEmailSignature`, {
    	method: "POST",
    	body: JSON.stringify({
    		signatureId:signatureId
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to delete email signature", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const addEmailTemplate = async(routingProfile: string, templateName:string, emailTemplate:string, templateStatus:string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}addEmailTemplate`, {
    	method: "POST",
    	body: JSON.stringify({
    		routingProfile:routingProfile,
			templateName:templateName,
			emailTemplate:emailTemplate,
			templateStatus:templateStatus
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to add email template", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const updateEmailTemplate = async(templateId: string, emailTemplate:string, templateName:string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}updateEmailTemplate`, {
    	method: "POST",
    	body: JSON.stringify({
    		templateId:templateId,
			emailTemplate:emailTemplate,
			templateName:templateName
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to update email template", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const deleteEmailTemplate = async(templateId: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}deleteEmailTemplate`, {
    	method: "POST",
    	body: JSON.stringify({
    		templateId:templateId
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to delete email template", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const getEmailTemplateList = async(routingProfile: string) => {
    const response = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getEmailTemplateList`, {
    	method: "POST",
    	body: JSON.stringify({
    		routingProfile:routingProfile
    	}),
    });
    if(!response.ok) {
		return {success: false, message: "Unable to get email template list", data:null}
	} else {
		let result = await response.json()
		return {success: true, message: 'success', data:result}
	}
}

export const translateChatMessage = async(chatMessage: string, sourceLanguage: string, targetLanguage: string, contactId: string, Speaker: string,account?: string ) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}translateChatMessage`, {
		method: "POST",
		body: JSON.stringify({
			speaker: Speaker,
			chatMessage: chatMessage,
			sourceLanguage: sourceLanguage,
			targetLanguage: targetLanguage,
			account: account,
			contactId: contactId
		}),
	});

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const whisperAPI = async (message: string, contactId: string, account?: string) => {
    const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}whisper`, {
        method: "POST",
        body: JSON.stringify({
            message: message,
            account: account,
            contactId: contactId
        }),
    });

    if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	
    const blob = await resp.blob();
    return blob;
}



export const getMessagesByAccount = async(account: string) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}get-preset-messages-by-account`, {
		method: "POST",
		body: JSON.stringify({
			account: account
		}),
	});

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const getTimers = async(username: string) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getTimers`, {
		method: "POST",
		body: JSON.stringify({
			username: username
		}),
	})

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const getMisscalltimer = async(routingProfile: string) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getMisscallTimer`, {
		method: "POST",
		body: JSON.stringify({
			routingProfile: routingProfile
		}),
	});

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const sendFollowup = async(agentARN: string, caseNumber: string, queueId: string, messageChannel: string) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}sendFollowup`, {
		method: "POST",
		body: JSON.stringify({
			agentARN: agentARN,
			caseNumber: caseNumber,
			queueId: queueId,
			messageChannel: messageChannel
		})
	});

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const getTicketInfo = async(accountName: string, caseNumber: string, action: string) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getTicketInfo`, {
		method: "POST",
		body: JSON.stringify({
			accountName: accountName,
			caseNumber: caseNumber,
			action: action
		})
	});

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const getAccount = async (agentID: string) => {
	const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}getAccount`, {
		method: "POST",
		body: JSON.stringify({
			agentID: agentID
		})
	});

	if (!resp.ok) throw new Error("Non 200 response: " + resp.status);
	return await resp.json();
}

export const SendLogs = async(AgentUsername:string,HasAutoAnswer:boolean,RoutingProfile:string,ContactsIds:string[],ErrorID:string)=>{
	let Initiated = new Date().getTime()
	let responsetime = await fetch(`https://ieluqbvv.telemetry.connect.${process.env.REACT_APP_AWS_CCP_REGION}.amazonaws.com/ping`,{
		method: "GET",
		headers: {
			'Content-Type': 'application/json',
		  },
		  mode: "no-cors",
		  credentials: "same-origin"
	})
	.then(() => {
		let timetook =  new Date().getTime() - Initiated
		return timetook
})
	let InputDevices = JSON.parse(localStorage.getItem("InputDevices")||"[]")
	let OutputDevices = JSON.parse(localStorage.getItem("OutputDevices")||"[]")
	
      const resp = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}SendLogs`,{
          method: "POST",
          body: JSON.stringify({
                Username:AgentUsername,
                AutoAnswer:HasAutoAnswer,
                RoutingProfile: RoutingProfile,
                ContactIDs:ContactsIds,
                Browser:navigator.userAgent,
                Error: ErrorID,
				Ping:responsetime,
				InputDevices:InputDevices,
				OutputDevices:OutputDevices
			})
      })

}
